import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer';
import BottomNavigation from '../ui/BottomNavigation';

const Layout: React.FC = () => {
  // Get current location to check the path
  const location = useLocation();
  
  // Check if the current path is /list (any language)
  const isListPage = location.pathname.includes('/list');
  
  return (
    <div className="bg-mainBlack text-white min-h-screen flex flex-col">
      <main className="flex-grow page-main ">
        <Outlet />
      </main>
      <BottomNavigation />
      {/* Only show Footer when not on the list page */}
      {!isListPage && <Footer />}
    </div>
  );
};

export default Layout;
